// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"126":"[auth]","285":"[Home]","631":"[profile]"}[chunkId] || chunkId) + "." + {"34":"703873e7","126":"cb9e236c","285":"2ce590fc","387":"1dfbc145","411":"e0e699e7","631":"83196337","787":"4a21b8e5","996":"ece5cca2"}[chunkId] + ".chunk.js";
};